import { render, staticRenderFns } from "./DrugSearch.vue?vue&type=template&id=b82df5be"
import script from "./DrugSearch.vue?vue&type=script&lang=js"
export * from "./DrugSearch.vue?vue&type=script&lang=js"
import style0 from "./DrugSearch.vue?vue&type=style&index=0&id=b82df5be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports